import { GlobalAnnouncementConnected } from "./GlobalAnnouncementConnected";

export default GlobalAnnouncementConnected;
